module.exports = __webpack_public_path__ + "img/1529756178.3d4c8483.jpg";